<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('listeExerciceComptable.title') }}
                </h1>
                <app-breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button
                class="button is-addOrEdit"
                :class="{'button-access-no-permission' :
                !checkPermissions(permsExerciceComptable.maj)}"
                @click="checkPermissions(permsExerciceComptable.maj) ?
                $router.push({ name: 'm.parametrage.exercice_comptable-add' }) : showPopUp()">
                {{ $t('listeExerciceComptable.actions.add')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="recherche()" class="column is-12">
            <b-input :placeholder="$t('listeExerciceComptable.actions.search')"
                     type="search" icon="magnify" v-model="critereRecherche.auto">
            </b-input>
          </form>
        </div>
      </div>
      <div class="level-right">
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table url="" :columns="columns" :options="options" :ref="referenceTable"
                    @loaded="finLoading" @loading="debutLoading" v-if="startArrayRendering">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <div slot="etat" slot-scope="props">
        {{ props.row.etat === ouvert
        ? $i18n.t('listeExerciceComptable.etat.ouvert')
        : $i18n.t('listeExerciceComptable.etat.ferme') }}
      </div>
      <div slot="edit" slot-scope="props" class="has-text-centered">
        <a @click="$router.push({ name: 'm.parametrage.exercice_comptable-edit',
        params: { id: props.row.id} })">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permsExerciceComptable.maj)
              }"
          >
          </b-icon>
        </a>
      </div>
    </v-server-table>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import { EXERCICE_COMPTABLE } from '@/configuration/general/permissionsParametrageConf';
import inProgress from '@/services/general/inProgress';
import messageErreur from '@/services/general/messageErreur';
import {
  TEXTS, RESULTS_PER_PAGE, SORT_ICON, NO_PER_PAGE_VALUE,
} from '@/configuration/clientTableConf';
import { SET_DETECT_CHANGE_SOCIETE } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import { OUVERT } from '@/configuration/compta/exerciceComptable';
import TableItemsInView from '@/components/general/TableItemsInView';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_EXERCICE_COMPTABLE } from '@/configuration/general/referenceTableConf';

const permissions = createNamespacedHelpers('permissions');
const exerciceComptable = createNamespacedHelpers('exerciceComptable');
const societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      permsExerciceComptable: EXERCICE_COMPTABLE,
      critereRecherche: {},
      ouvert: OUVERT,
      startArrayRendering: false,
      referenceTable: REFERENCE_TABLE_EXERCICE_COMPTABLE,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  computed: {
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeExerciceComptable.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeExerciceComptable.title'), route: '', isActive: true },
      ];
      return output;
    },
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...exerciceComptable.mapGetters({
      items: 'items',
      totalCount: 'totalCount',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$t('listeExerciceComptable.tab.code'),
          dateDebut: this.$t('listeExerciceComptable.tab.dateDebut'),
          dateFin: this.$t('listeExerciceComptable.tab.dateFin'),
          etat: this.$t('listeExerciceComptable.tab.etat'),
          edit: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = {
            auto: this.critereRecherche.auto,
          };
          data.query.societeId = this.societeActiveId;
          return this.actionsLoadExerciceComptable(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          edit: 'colonneSelected',
        },
        sortable: ['code', 'etat', 'dateDebut', 'dateFin'],
      };
    },
    columns() {
      return ['code', 'dateDebut', 'dateFin', 'etat', 'edit'];
    },
  },
  components: {
    AppBreadcrumb: breadcrumb,
    TableItemsInView,
    parametrageTable,
  },
  beforeDestroy() {
    this.unsubscribeValue();
  },
  methods: {
    ...exerciceComptable.mapActions({
      actionsLoadExerciceComptable: 'loadExerciceComptable',
    }),
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.setInformationPage(this.$t('pageCompta.exerciceComptable.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};

</script>
